export default "__VITE_ASSET__zhIHUdf0__"